// 数据海报 顶部菜单
module.exports = {
  sportType: 'dataPoster',
  menuSeasonName: '数据海报',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        {
          name: '海报库',
          key: 'posterLibrary',
          routeName: 'posterLibraryIndex',
          act: true,
        },
        // {
        //   name: '编辑工作站',
        //   key: 'workstation',
        //   routeName: 'workstationIndex',
        //   act: false,
        // },
        // {
        //   name: '我的作品',
        //   key: 'myPortfolio',
        //   routeName: 'myPortfolioIndex',
        //   act: false,
        // },
      ],
    },
    // {
    //   name: 'openMenu',
    //   arr: [
    //     {
    //       name: '节目单',
    //       key: 'programList',
    //       routeName: 'CSMeetProgramListIndex_ASG',
    //       act: false,
    //       isOpenWeb: true,
    //     },
    //     {
    //       name: '播出单',
    //       key: 'broadcastList',
    //       routeName: 'CSMeetBroadcastListIndex_ASG',
    //       act: false,
    //       isOpenWeb: true,
    //     },
    //     {
    //       name: '数据包装',
    //       key: 'dataPackagList',
    //       routeName: 'CSMeetDataPackagListIndex_ASG',
    //       act: false,
    //       isOpenWeb: true,
    //     },
    //   ],
    // },
  ],
}
